/* @flow */
import Entity from 'lib/Entity';
import { cloneDeep } from 'lodash';
import apiRequest from 'lib/apiRequest';
import ExternalAccountResource from 'entities/ExternalAccountResource';

export const STATUS_PENDING = 'pending';
export const STATUS_REVOKED = 'revoked';
export const STATUS_APPROVED = 'approved';

export default class ConnectedBankAccount extends Entity {
  initialize() {
    this.idAttribute = 'uuid';
  }

  parse(response: Object) {
    const request = cloneDeep(response);
    if (request['revoked_at']) {
      request['revoked_at'] = new Date(request['revoked_at']);
    }

    if (request['approved_at']) {
      request['approved_at'] = new Date(request['approved_at']);
    }

    if (request['requested_at']) {
      request['requested_at'] = new Date(request['requested_at']);
    }

    if (request['external_account']) {
      request['external_account'] = ExternalAccountResource.fromJSON(request['external_account']);
    }

    return request;
  }

  getBankId() {
    return this.get('bank_id');
  }

  getConnectedUserUUID() {
    return this.get('connected_user_uuid');
  }

  getConnectedUserName() {
    return this.get('connected_user_name');
  }

  getNote() {
    return this.get('note');
  }

  getOrganizationName() {
    return this.get('organization_name');
  }

  getOwnerName() {
    return this.get('owner_name');
  }

  getOwnerAddress() {
    return this.get('owner_address');
  }

  getOwnerUUID() {
    return this.get('owner_uuid');
  }

  getRevokedAt() {
    return this.get('revoked_at');
  }

  getApprovedAt() {
    return this.get('approved_at');
  }

  getRequestedAt() {
    return this.get('requested_at');
  }

  isApproved() {
    return this.getStatus() === STATUS_APPROVED;
  }

  getStatus() {
    return this.get('status');
  }

  isPending() {
    return this.get('status') === STATUS_PENDING;
  }

  getExternalAccount() {
    return this.get('external_account');
  }

  getCanManage() {
    return this.get('can_manage');
  }

  static getConnectedBankAccount(accessToken) {
    return apiRequest('/payments/connected_bank_account/', 'GET', {
      access_token: accessToken,
    }).then(response => ConnectedBankAccount.fromJSON(response));
  }

  static requestAccess(ownerName, ownerEmail, note, schoolId) {
    return apiRequest('/payments/connected_bank_accounts', 'POST', {
      owner_name: ownerName,
      owner_email: ownerEmail,
      reason: note,
      organization_id: schoolId,
    }).then(account => {
      return ConnectedBankAccount.fromJSON(account);
    });
  }

  static approve(token, bankAccountName, accessToken, connectedBankAccountId) {
    return apiRequest('/payments/connected_bank_accounts/approve', 'POST', {
      token,
      display_name: bankAccountName,
      access_token: accessToken,
      uuid: connectedBankAccountId,
    })
    .then(response => ConnectedBankAccount.fromJSON(response));
  }

  revokeAccess() {
    return apiRequest(`/payments/connected_bank_accounts/${this.id}/revoke`, 'POST')
      .then(response => ConnectedBankAccount.fromJSON(response));
  }
}



// WEBPACK FOOTER //
// ./src/entities/ConnectedBankAccount.js